import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Flex, Loader, Tooltip } from "@fluentui/react-northstar";
import {
    ToDoListIcon, SettingsIcon, PollIcon, ShiftActivityIcon, TenantWorkIcon, ArrowLeftIcon, GlobeIcon

} from "@fluentui/react-icons-northstar";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useApp } from "../contexts/appContext";
import styles from "./navigation.module.scss";
import useWindowDimensions from "../common/useWindowDimensions";

const Navigation: React.FunctionComponent = () => {
    const { width } = useWindowDimensions();
    const [selected, setSelected] = useState(window.location.pathname);
    const [narrowView, setNarrowView] = useState(false);
    const history = useHistory();
    const { state, dispatch } = useApp();
    const { backgroundColor, showLoader } = state;
    // Every running query and mutation counts, one finishing must not hide the indicator of another.
    // Both hooks have to be called on every render, so they must not sit behind a short circuit.
    const fetching = useIsFetching();
    const mutating = useIsMutating();
    const busy = fetching > 0 || mutating > 0 || showLoader;

    useEffect(() => {
        setNarrowView(width <= 500);
    }, [width]);

    const onClick = (url: string) => {
        history.push(url);
        setSelected(url);

        dispatch({ type: "SET_REPORTS_QUERY", query: "" });
        dispatch({ type: "SET_PROJECTS_QUERY", query: "" });
        dispatch({ type: "SET_TASKS_QUERY", query: "" });
    };

    const homeSelected = selected === "/" || selected.indexOf("/#") > -1 || selected.indexOf("/report") > -1;
    const projectsSelected = selected.indexOf("/project") > -1;
    const tasksSelected = selected.indexOf("/task") > -1;
    const dashboardSelected = selected === "/dashboard";
    const settingsSelected = selected === "/settings";
    const toolsSelected = selected === "/tools";

    return (
        <div className={styles.container} style={{ backgroundColor }}>
            <Flex className={styles.centerContainer}>
                <Flex className={styles.navItems}>
                    <Button
                        text
                        iconOnly
                        icon={<ArrowLeftIcon />}
                        onClick={history.goBack}
                    />
                    <Button
                        content={!narrowView && "Výkazy"}
                        primary={homeSelected}
                        text
                        iconOnly={narrowView}
                        icon={<ShiftActivityIcon />}
                        onClick={() => onClick("/")}
                    />
                    <Button
                        content={!narrowView && "Případy"}
                        primary={projectsSelected}
                        text iconOnly={narrowView}
                        icon={<TenantWorkIcon />}
                        onClick={() => onClick("/projects")}
                    />
                    <Button
                        content={!narrowView && "Úkoly"}
                        primary={tasksSelected}
                        text
                        iconOnly={narrowView}
                        icon={<ToDoListIcon />}
                        onClick={() => onClick("/tasks")}
                    />
                    <Button
                        content={!narrowView && "Dashboard"}
                        primary={dashboardSelected}
                        text
                        iconOnly={narrowView}
                        icon={<PollIcon rotate={90} />}
                        onClick={() => onClick("/dashboard")}
                    />
                    <Button
                        content={!narrowView && "Nástroje"}
                        primary={toolsSelected}
                        text
                        iconOnly={narrowView}
                        icon={<GlobeIcon />}
                        onClick={() => onClick("/tools")}
                    />
                </Flex>
                {busy && <Loader size="small" className={styles.loader} />}
                <Flex.Item push>
                    <div>
                        <Tooltip
                            trigger={<Button text iconOnly primary={settingsSelected} icon={<SettingsIcon />} onClick={() => onClick("/settings")} />}
                            content="Nastavení"
                        />
                    </div>
                </Flex.Item>
            </Flex>
        </div>
    );
};

export default Navigation;
